import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=0f084bf6&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=0f084bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f084bf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f084bf6')) {
      api.createRecord('0f084bf6', component.options)
    } else {
      api.reload('0f084bf6', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=0f084bf6&scoped=true&", function () {
      api.rerender('0f084bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20C1P7QHSytDB/JS/comp/GuestBox.vue"
export default component.exports